<template>
    <div class="flex-grow">

        <label
            v-if="label"
            class="select-none"
        >{{ label }}</label>
        <textarea
            ref="input"
            :value="value"
            :class="inputClasses"
            :maxlength="maxlength"
            rows="5"
            @input="handleInput($event)"
        />

        <transition name="slide-in-out">
            <div
                v-if="invalid"
                class="text-sm mt-2 text-red-light"
            >
                <slot name="errors" />
            </div>
        </transition>

        <transition name="slide-in-out">
            <div
                v-if="success"
                class="text-sm mt-2 text-green-light"
            >
                <slot name="success" />
            </div>
        </transition>

    </div>
</template>
 
<script>
export default {

    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: '',
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        success: {
            type: Boolean,
            default: false,
        },
        maxlength: {
            type: Number,
            default: null,
        },
    },

    computed: {
        isEmpty() {
            return this.value.length === 0;
        },
        inputClasses() {
            let classes = '';
            if (!this.isEmpty) {
                classes += ' not-empty';
            }
            if (this.invalid) {
                classes += ' invalid';
            }
            return classes;
        },
    },

    watch: {
        focused(newValue) {
            if (newValue) {
                this.focusInput();
            }
        },
    },

    mounted() {
        if (this.focused) {
            this.focusInput();
        }
    },

    methods: {
        handleInput(event) {
            this.$emit('input', event.target.value);
        },
    },

};
</script>

<style lang="scss" scoped>
label {
    @apply block text-xs uppercase tracking-wide font-semibold text-grey-darker mb-1;
}
textarea {
    border: 2px solid;
    @apply bg-grey-lighter rounded border-grey-lighter transition-fast w-full p-3 block;
    &:focus,
    &.not-empty {
        @apply border-primary outline-none;
    }
    &.invalid {
        @apply border-red-light;
    }
}
.slide-in-out-enter-active,
.slide-in-out-leave-active {
    @apply transition-slow;
}
.slide-in-out-enter,
.slide-in-out-leave-to {
    @apply opacity-0 absolute;
    transform: translateX(10px);
}
</style>
